import { render, staticRenderFns } from "./CorrectionView.vue?vue&type=template&id=56e119c9&scoped=true&"
import script from "./CorrectionView.vue?vue&type=script&lang=js&"
export * from "./CorrectionView.vue?vue&type=script&lang=js&"
import style0 from "./CorrectionView.vue?vue&type=style&index=0&id=56e119c9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e119c9",
  null
  
)

export default component.exports